import { Reference } from "./reference.js";
import { IValue } from "../core/ivalue";
/**
 * Bind some values to one expression
 * @class Expression
 * @extends IValue
 */
export class Expression extends IValue {
    constructor(func, link, v1, v2, v3, v4, v5, v6, v7, v8, v9) {
        super(false);
        /**
         * Expression will link different handler for each value of list
         */
        this.linkedFunc = [];
        const values = [v1, v2, v3, v4, v5, v6, v7, v8, v9].filter(v => v instanceof IValue);
        const handler = (i) => {
            if (i != null) {
                this.valuesCache[i] = this.values[i].$;
            }
            this.sync.$ = func.apply(this, this.valuesCache);
        };
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        this.valuesCache = values.map(iValue => iValue.$);
        this.sync = new Reference(func.apply(this, this.valuesCache));
        let i = 0;
        values.forEach(() => {
            this.linkedFunc.push(handler.bind(this, Number(i++)));
        });
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        this.values = values;
        this.func = handler;
        if (link) {
            this.enable();
        }
        else {
            handler();
        }
        this.$seal();
    }
    get $() {
        return this.sync.$;
    }
    set $(value) {
        this.sync.$ = value;
    }
    on(handler) {
        this.sync.on(handler);
        return this;
    }
    off(handler) {
        this.sync.off(handler);
        return this;
    }
    enable() {
        if (!this.isEnabled) {
            for (let i = 0; i < this.values.length; i++) {
                this.values[i].on(this.linkedFunc[i]);
                this.valuesCache[i] = this.values[i].$;
            }
            this.func();
            this.isEnabled = true;
        }
        return this;
    }
    disable() {
        if (this.isEnabled) {
            for (let i = 0; i < this.values.length; i++) {
                this.values[i].off(this.linkedFunc[i]);
            }
            this.isEnabled = false;
        }
        return this;
    }
    $destroy() {
        this.disable();
        this.values.splice(0);
        this.valuesCache.splice(0);
        this.linkedFunc.splice(0);
        super.$destroy();
    }
}
